export const UNITS_NONE = 'UNITS_NONE';
export const UNITS_IMPERIAL = 'UNITS_IMPERIAL';
export const UNITS_METRIC = 'UNITS_METRIC';
